module.exports = __webpack_public_path__ + "static/david-kerr-710e4c9d48678bc3d13288ab8d3cfcc3.jpg";